/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_cc002c0e","_cc002c0e",""]'><div :class='["","_cc002c0e",""]'><div :class='["","_cc002c0e",""]'>通过默认slot 传入展开、收起的内容</div><div :class='["bg-white","_cc002c0e",""]'><cube-collapse :class='["","_cc002c0e",""]'><div :class='["","_cc002c0e",""]'>内容文案，第一行</div><div :class='["","_cc002c0e",""]'>内容文案，第二行</div><div :class='["","_cc002c0e",""]'>内容文案，第三行</div><div :class='["","_cc002c0e",""]'>内容文案，第四行</div></cube-collapse></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_cc002c0e"}'>
.bg-white
  margin-top: 6px
  background-color: #fff
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_cc002c0e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_cc002c0e"}
  /** script content **/
  require("./basic-collapse.mpx.js?isComponent&outputPath=components%2Fbasic-collapsecc002c0e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-collapse.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-collapsecc002c0e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_cc002c0e"],
    ctorType: "component",
    outputPath: "components/basic-collapsecc002c0e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-collapse':getComponent(require("../../../packages/mpx-cube-ui/src/components/collapse/index.mpx?isComponent&outputPath=components%2Findex5127b398%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>